import { ReactNode } from 'react';
import {
  Icon as MUIIcon,
  IconProps as MUIIconProps,
  SxProps,
} from '@mui/material';
import * as R from 'ramda';

import colors from '@atom/styles/colors';

type CustomProps = {
  /**
   * color to apply to the icon
   * defaults to #999
   */
  color?: string;
  /**
   * optional styles to apply to the
   * the root of the component
   */
  style?: any;
  /**
   * generate an invisible icon
   */
  invisible?: boolean;
};

type AtomMUIProps = {
  children?: ReactNode;
  className?: string;
  onClick?: (event: any) => void;
};

export type IconProps = CustomProps & AtomMUIProps;

export const Icon = (props: IconProps) => {
  const MUIProps: MUIIconProps = R.omit(['color'], props);

  const sx: SxProps = {
    ...props.style,
    color: props.color || colors.neutral.gray,
    fontSize: '24px',
    height: 'auto',
    paddingLeft: '0',
    visibility: props.invisible ? 'hidden' : 'inherit',
  };

  return <MUIIcon {...MUIProps} sx={sx} />;
};

export default Icon;
